import { injectable } from 'inversify';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { GameIdentity } from '@/components/game/_domain/models';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';

interface IGameControllerFactory {
  getControllerForGame(gameIdentity: GameIdentity): IGameController;
}

@injectable()
class GameControllerFactory implements IGameControllerFactory {
  private readonly gameControllerMappings: { [key: string]: symbol } = {
    default: SERVICE_IDENTIFIERS.BaseGameController,
    hamsterrace: SERVICE_IDENTIFIERS.HamsterRaceGameController,
    bingo75: SERVICE_IDENTIFIERS.Bingo75GameController,
    bingo75lines: SERVICE_IDENTIFIERS.Bingo75LinesGameController,
    britainsbiggestbingo: SERVICE_IDENTIFIERS.BritainsBiggestBingoGameController,
    cinco: SERVICE_IDENTIFIERS.CincoGameController,
    bingo40: SERVICE_IDENTIFIERS.Bingo40GameController,
    bingo60: SERVICE_IDENTIFIERS.Bingo60GameController,
    tombolaroulette: SERVICE_IDENTIFIERS.TombolaRouletteController,
    picturebingo: SERVICE_IDENTIFIERS.PictureBingoGameController,
    potion: SERVICE_IDENTIFIERS.PotionGameController,
    themachine: SERVICE_IDENTIFIERS.TheMachineGameController,
    hex: SERVICE_IDENTIFIERS.HexGameController,
    bubblebingo: SERVICE_IDENTIFIERS.BubbleBingoGameController,
    wordsearch: SERVICE_IDENTIFIERS.WordSearchGameController,
    dondbingo: SERVICE_IDENTIFIERS.DondBingoGameController,
  };

  private readonly gameControllerMappingsSpain: { [key: string]: symbol } = {
    default: SERVICE_IDENTIFIERS.BaseGameController,
    bingo75: SERVICE_IDENTIFIERS.Bingo75GameController,
    cinco: SERVICE_IDENTIFIERS.ESCincoGameController,
    picturebingo: SERVICE_IDENTIFIERS.ESPictureBingoGameController,
  };

  private readonly gameControllerMappingsItaly: { [key: string]: symbol } = {
    default: SERVICE_IDENTIFIERS.BaseGameController,
    cinco: SERVICE_IDENTIFIERS.ITCincoGameController,
    bingo75: SERVICE_IDENTIFIERS.ITBingo75GameController
  };

  private readonly gameControllerMappingsSweden: { [key: string]: symbol } = {
    default: SERVICE_IDENTIFIERS.BaseGameController,
    bingo75: SERVICE_IDENTIFIERS.SEBingo75GameController
  };

  private readonly gameControllerMappingsNetherlands: { [key: string]: symbol } = {
    default: SERVICE_IDENTIFIERS.BaseGameController,
    picturebingo: SERVICE_IDENTIFIERS.NLPictureBingoGameController
  };

  public getControllerForGame(gameIdentity: GameIdentity): IGameController {
    const gameController = this.selectControllerForGame(gameIdentity);
    gameController.initialise(gameIdentity);
    return gameController;
  }

  private selectControllerForGame(gameIdentity: GameIdentity): IGameController {
    const gameName = gameIdentity.nameForConfiguration;
    const persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
    const userPreferences = persistedStore.Get(UserPreferences);
    const userCountry: string = userPreferences.country.toLowerCase();

    let gameControllerSymbol;

    switch (userCountry) {
      case 'it':
        gameControllerSymbol = this.gameControllerMappingsItaly[gameName] || this.gameControllerMappings.default;
        break;
      case 'es':
        gameControllerSymbol = this.gameControllerMappingsSpain[gameName] || this.gameControllerMappings.default;
        break;
      case 'se':
        gameControllerSymbol = this.gameControllerMappingsSweden[gameName] || this.gameControllerMappings.default;
      case 'nl':
        gameControllerSymbol = this.gameControllerMappingsNetherlands[gameName] || this.gameControllerMappings.default;
        break;
      default:
        gameControllerSymbol = this.gameControllerMappings[gameName] || this.gameControllerMappings.default;
        break;
    }


    return container.get(gameControllerSymbol);
  }
}

export { IGameControllerFactory, GameControllerFactory };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_factory/game-controller-factory.ts